var youbora = require('youboralib')
var VideojsAdapter = require('youbora-adapter-videojs')
var manifest = require('../manifest.json')

var BrightcoveVideojsAdapter = VideojsAdapter.extend({
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  getDuration: function () {
    if (this.player.mediainfo && typeof this.player.mediainfo.duration !== 'undefined') {
      return this.player.mediainfo.duration
    } else {
      VideojsAdapter.prototype.getDuration.apply(this, arguments) // super
    }
  },

  getTitle: function () {
    if (this.player.mediainfo) {
      return this.player.mediainfo.name
    } else {
      VideojsAdapter.prototype.getTitle.apply(this, arguments) // super
    }
  },

  getPlayerName: function () {
    var name = VideojsAdapter.prototype.getPlayerName.apply(this, arguments) // super
    if (this.player.mediainfo) name += '-bcove' // brightcove
    return name
  },

  loadAdsAdapter: function () {
    if (this.plugin.getAdsAdapter() === null) {
      var adapter
      if (typeof google !== 'undefined' && this.player.ima3) { // BC + IMA
        adapter = new BrightcoveVideojsAdapter.BrightcoveAdsAdapter(this.player)
      } else {
        adapter = VideojsAdapter.prototype.loadAdsAdapter.apply(this, arguments) // super
      }

      this.plugin.setAdsAdapter(adapter)
    }
  }
},
  // Static members
  {
    // Brightcove ads adapter
    BrightcoveAdsAdapter: require('./ads/brightcove-ads'),

    // Base adapter, brighcove-less
    BaseVideojsAdapter: VideojsAdapter
  }
)

youbora.adapters.BrightcoveVideojs = BrightcoveVideojsAdapter

module.exports = BrightcoveVideojsAdapter
